// About Us Page Content
import { FaBullseye, FaRocket, FaGem, FaHandshake, FaBolt, FaLightbulb, FaChartLine } from 'react-icons/fa';

export const aboutContent = {
  hero: {
    title: "نحن نمو ماركتينج",
    subtitle: "شريكك في النجاح الرقمي",
    description: "وكالة تسويق رقمي متخصصة تساعد الشركات والأفراد على بناء حضور قوي ومؤثر على الإنترنت. نؤمن بأن كل مشروع يستحق فرصة للنمو والتميز.",
    imageUrl: "https://via.placeholder.com/800x500/1A4D5C/2DD4BF?text=Nomu+Marketing"
  },

  story: {
    title: "قصتنا",
    content: `بدأنا نمو ماركتينج من إيمان عميق بأن التسويق الرقمي ليس مجرد خدمة، بل هو شراكة حقيقية تهدف لنمو مشروعك.

منذ انطلاقنا، ساعدنا العشرات من الشركات والأفراد في المملكة العربية السعودية والإمارات على:`,
    achievements: [
      "بناء هوية رقمية قوية",
      "زيادة التفاعل مع جمهورهم",
      "تحقيق نتائج ملموسة ومستدامة"
    ],
    closing: "نعمل بشغف وتفان لأننا نعتبر نجاحك هو نجاحنا."
  },

  vision: {
    icon: FaBullseye,
    title: "رؤيتنا",
    description: "أن نكون الخيار الأول للشركات والأفراد الذين يبحثون عن حلول تسويقية رقمية مبتكرة واحترافية في المنطقة."
  },

  mission: {
    icon: FaRocket,
    title: "رسالتنا",
    description: "نساعد عملاءنا على النمو من خلال تقديم خدمات تسويق رقمي متكاملة، مبنية على الإبداع والاحترافية والالتزام بالنتائج."
  },

  values: {
    title: "قيمنا",
    subtitle: "المبادئ التي نعمل بها",
    items: [
      {
        id: 1,
        icon: FaGem,
        title: "الاحترافية",
        description: "نلتزم بأعلى معايير الجودة في كل ما نقدمه"
      },
      {
        id: 2,
        icon: FaHandshake,
        title: "الشراكة",
        description: "نجاحك هو نجاحنا، ونعمل معك كفريق واحد"
      },
      {
        id: 3,
        icon: FaBolt,
        title: "السرعة",
        description: "نحترم وقتك ونلتزم بالمواعيد"
      },
      {
        id: 4,
        icon: FaLightbulb,
        title: "الإبداع",
        description: "نقدم أفكار مبتكرة تميزك عن المنافسين"
      },
      {
        id: 5,
        icon: FaChartLine,
        title: "النتائج",
        description: "نؤمن بالنتائج الملموسة والقابلة للقياس"
      },
      {
        id: 6,
        icon: FaHandshake,
        title: "الشفافية",
        description: "نتواصل بوضوح ونبني علاقات مبنية على الثقة"
      }
    ]
  },

  team: {
    title: "فريق من الخبراء",
    subtitle: "فريق متخصص من المصممين، المطورين، ومديري الحملات الإعلانية",
    description: "كلنا نعمل بشغف لتحقيق أهدافك",
    note: "صور الفريق يمكن إضافتها لاحقاً"
  },

  cta: {
    title: "جاهز للانطلاق معنا؟",
    subtitle: "دعنا نساعدك في تحقيق أهدافك الرقمية",
    buttonText: "تواصل معنا الآن 💬"
  }
};
